import { PayableOption } from '@shared/models/payable-option';
import { IProduct, Product } from '@shared/models/product';
import { Contract, IContract } from '@shared/models/contract';
import { ElectricMeterProductType } from '@shared/models/electric-meter-product-type';

export interface TenantRelationRaw {
    id: number;
    name: string;
    note: string;
    hexColor?: string;
    hexBgColor?: string;
    payableOption: PayableOption;
    electricMeterProductType: ElectricMeterProductType;
    electricitySwitchableViaApp: boolean;
    products?: IProduct[];
    /** 0/1 from the slim list endpoints, which omit `products` (perf(6622)). */
    hasProducts?: boolean | number;
    contracts: IContract[];
}

export class TenantRelation {
    id: number;
    name: string;
    note: string;
    hexColor?: string;
    hexBgColor?: string;
    payableOption: PayableOption;
    electricMeterProductType: ElectricMeterProductType;
    electricitySwitchableViaApp: boolean;
    products?: Product[];
    /**
     * Whether the relation carries fees — the only thing that decides if the subscription fields
     * have to be filled. The slim list endpoints ship it because they no longer ship `products`;
     * `getOne` responses carry the products themselves, so it is derived from them there. (#6928)
     */
    hasProducts: boolean;
    contracts: Contract[];

    constructor(tenantRelation: TenantRelationRaw) {
        if (!tenantRelation) {
            return;
        }

        this.id = tenantRelation.id;
        this.name = tenantRelation.name;
        this.note = tenantRelation.note;
        this.hexColor = tenantRelation.hexColor;
        this.hexBgColor = tenantRelation.hexBgColor;
        this.products = (tenantRelation.products || []).map(product => new Product(product));
        this.hasProducts = tenantRelation.hasProducts != null
            ? !!tenantRelation.hasProducts
            : this.products.length > 0;
        this.contracts = (tenantRelation.contracts || []).map(contract => new Contract(contract));
        this.electricMeterProductType = tenantRelation.electricMeterProductType;
        this.electricitySwitchableViaApp = tenantRelation.electricitySwitchableViaApp;
        this.payableOption = tenantRelation.payableOption;
    }
}

export type TenantRelationWithDisable = TenantRelation & { disabled?: boolean, disabledReason?: string };
